module.exports = __webpack_public_path__ + "img/ico-more.5095d66e.svg";